var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup31(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5E1E61CC-2CF4-4EC4-B145-6CF0ACD4D797") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-357.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(358.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.84938,16.79945 C24.75278,16.79945 25.48508,17.53175 25.48508,18.43515 C25.48508,19.33855 24.75278,20.07085 23.84938,20.07085 C22.94598,20.07085 22.21368,19.33855 22.21368,18.43515 C22.21368,17.53175 22.94598,16.79945 23.84938,16.79945 Z",
    id: "Stroke-1",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2006,25.12318 C22.3148,24.66668 23.5881,25.19988 24.0446,26.31398 C24.5011,27.42818 23.968,28.70148 22.8538,29.15798 C21.7396,29.61448 20.4663,29.08138 20.0098,27.96708 C19.5533,26.85298 20.0864,25.57968 21.2006,25.12318 Z",
    id: "Stroke-3",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.85626,12.50629 L18.35276,14.09039 L14.39326,12.31769 C13.20786,11.72709 11.87766,12.93399 12.40986,14.18459 L14.08496,18.10199 L5.57496,20.97169 C4.25596,21.41439 4.26106,23.30239 5.59716,23.72639 L14.21926,26.46689 L12.44666,30.42649 C11.85606,31.61199 13.06286,32.94209 14.31356,32.40989 L18.23086,30.73489 L21.10056,39.24489 C21.54326,40.56379 23.43126,40.55869 23.85526,39.22269 L26.59586,30.60039 L30.55536,32.37309 C31.74076,32.96369 33.07086,31.75679 32.53876,30.50619 L30.86366,26.58879 L32.03266,26.19469 M39.37366,23.71919 C40.69266,23.27649 40.68756,21.38849 39.35156,20.96439 L30.72936,18.22389 L32.50196,14.26429 C33.09266,13.07899 31.88566,11.74879 30.63506,12.28089 L26.71766,13.95589 L23.84806,5.44599 C23.40536,4.12699 21.51736,4.13209 21.09336,5.46819",
    id: "Stroke-5",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16642,18.78383 C17.16642,19.18533 17.49192,19.51083 17.89342,19.51083 L17.89392,19.51083 C18.29542,19.51083 18.62072,19.18533 18.62072,18.78383 C18.62072,18.38223 18.29492,18.05673 17.89342,18.05673 C17.49192,18.05673 17.16642,18.38223 17.16642,18.78383",
    id: "Fill-7",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92662,23.20033 C29.32812,23.20033 29.65342,22.87493 29.65342,22.47333 C29.65342,22.07183 29.32762,21.74643 28.92612,21.74643 C28.52462,21.74643 28.19912,22.07183 28.19912,22.47333 C28.19912,22.87493 28.52462,23.20033 28.92612,23.20033 L28.92662,23.20033 Z",
    id: "Fill-9",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16583,21.38285 C19.76433,21.38285 19.43883,21.70835 19.43883,22.10995 C19.43883,22.51135 19.76433,22.83685 20.16583,22.83685 L20.16633,22.83685 C20.56793,22.83685 20.89313,22.51135 20.89313,22.10995 C20.89313,21.70835 20.56733,21.38285 20.16583,21.38285",
    id: "Fill-11",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64147,22.61879 C12.64147,23.02029 12.96697,23.34579 13.36847,23.34579 L13.36897,23.34579 C13.77047,23.34579 14.09567,23.02029 14.09567,22.61879 C14.09567,22.21719 13.76997,21.89169 13.36847,21.89169 C12.96697,21.89169 12.64147,22.21719 12.64147,22.61879",
    id: "Fill-13",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.47164,28.07123 L27.47214,28.07123 C27.87364,28.07123 28.19884,27.74573 28.19884,27.34423 C28.19884,26.94273 27.87314,26.61723 27.47164,26.61723 C27.07014,26.61723 26.74464,26.94273 26.74464,27.34423 C26.74464,27.74573 27.07014,28.07123 27.47164,28.07123",
    id: "Fill-15",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.74703,33.52367 C21.74703,33.92527 22.07253,34.25077 22.47403,34.25077 L22.47453,34.25077 C22.87613,34.25077 23.20133,33.92527 23.20133,33.52367 C23.20133,33.12217 22.87553,32.79667 22.47403,32.79667 C22.07253,32.79667 21.74703,33.12217 21.74703,33.52367",
    id: "Fill-17",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72359,10.50629 C20.12509,10.50629 20.45059,10.18079 20.45059,9.77919 C20.45059,9.37779 20.12509,9.05229 19.72359,9.05229 L19.72309,9.05229 C19.32159,9.05229 18.99639,9.37779 18.99639,9.77919 C18.99639,10.18079 19.32209,10.50629 19.72359,10.50629",
    id: "Fill-19",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.11881,24.42699 L35.11821,24.42699 C34.71671,24.42699 34.39151,24.75249 34.39151,25.15399 C34.39151,25.55549 34.71731,25.88089 35.11881,25.88089 C35.52031,25.88089 35.84581,25.55549 35.84581,25.15399 C35.84581,24.75249 35.52021,24.42699 35.11881,24.42699",
    id: "Fill-21",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69093,22.34545 C44.69093,34.68645 34.68653,44.69085 22.34543,44.69085 C10.00443,44.69085 3e-05,34.68645 3e-05,22.34545 C3e-05,10.00435 10.00443,-5e-05 22.34543,-5e-05 C34.68653,-5e-05 44.69093,10.00435 44.69093,22.34545 Z",
    id: "Stroke-23",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93019,8.0476 C43.93019,12.2633 40.51269,15.6808 36.29689,15.6808 C32.08119,15.6808 28.66369,12.2633 28.66369,8.0476 C28.66369,3.8319 32.08119,0.4143 36.29689,0.4143 C40.51269,0.4143 43.93019,3.8319 43.93019,8.0476",
    id: "Fill-25",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04274,
    y1: 5.7934,
    x2: 38.55114,
    y2: 10.3018,
    id: "Stroke-27",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-29",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group 31.18b24e74.svg";
export { ForwardRef as ReactComponent };